/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FundingRequestCloseRequestDto
 */
export interface FundingRequestCloseRequestDto {
  /**
   *
   * @type {string}
   * @memberof FundingRequestCloseRequestDto
   */
  comment: string;
}

export function FundingRequestCloseRequestDtoFromJSON(json: any): FundingRequestCloseRequestDto {
  return FundingRequestCloseRequestDtoFromJSONTyped(json, false);
}

export function FundingRequestCloseRequestDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FundingRequestCloseRequestDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    comment: json["comment"],
  };
}

export function FundingRequestCloseRequestDtoToJSON(value?: FundingRequestCloseRequestDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    comment: value.comment,
  };
}
